import {
    isLessonRecordLocked as isLessonRecordLockedHelper,
    lessonRecordDaysRemaining as lessonRecordDaysRemainingHelper,
} from "@/mixins/lesson-record-access-helpers";

export default {
    computed: {
        isPremium() {
            return Boolean(this.$store.state.user && this.$store.state.user.has_premium);
        },
    },
    methods: {
        isLessonRecordLocked(lesson) {
            return isLessonRecordLockedHelper({
                lesson,
                isPremium: this.isPremium,
                now: this.$date(),
            });
        },
        lessonRecordDaysRemaining(lesson) {
            return lessonRecordDaysRemainingHelper({
                lesson,
                now: this.$date(),
            });
        },
        openGenericPaywall() {
            this.$premiumPaywall({
                onSubscribe: (payload) => {
                    this.$premiumPaywallSubscribe(payload);
                },
            });
        },
        openLessonRecordPaywall(lesson) {
            if (!lesson) {
                this.openGenericPaywall();

                return;
            }

            this.$premiumPaywall({
                variant: "lessonRecord",
                daysRemaining: this.lessonRecordDaysRemaining(lesson),
                onSubscribe: (payload) => {
                    this.$premiumPaywallSubscribe(payload);
                },
            });
        },
    },
};
